<style lang="scss">
.UserAmountModul {
    .row {
        padding: 10px 0;
        border-bottom: 1px solid #eee;
        &:last-child {
            border-bottom: none;
        }
    }
    .label {
        font-weight: bold;
        margin-bottom: 6px;
    }
    .current {
        color: #666;
        margin-bottom: 8px;
    }
    .preview {
        margin-top: 8px;
        color: #4477ad;
    }
    .max-tip {
        font-weight: normal;
        font-size: 12px;
        color: #f56c6c;
    }
    .used-tip {
        font-weight: normal;
        font-size: 12px;
        color: #909399;
    }
}
</style>
<template>
    <el-dialog class="UserAmountModul" :title="Title" :visible.sync="view" width="520px" top="12vh" :modal-append-to-body="false" :close-on-click-modal="false">
        <div v-loading="loading">
            <p class="o-mb">帐号：<b>{{ Params.username }}</b>（{{ Params.real_name || '-' }}）</p>
            <div v-for="item in amountFields" :key="item.key" class="row">
                <p class="label">
                    {{ item.label }}
                    <span class="max-tip">（最高：{{ maxIncreaseHint(item.key) }}）</span>
                    <span v-if="isCreditKey(item.key)" class="used-tip">（已用：{{ usedAmountHint(item.key) }}）</span>
                </p>
                <p class="current">当前额度：{{ formatAmount(Params[item.key]) }}</p>
                <div class="l-flex-c">
                    <el-radio-group v-model="adjust[item.key].mode" size="small">
                        <el-radio :label="1">增加</el-radio>
                        <el-radio :label="-1">减少</el-radio>
                    </el-radio-group>
                    <span class="o-pl">调整金额：</span>
                    <el-input v-model.number="adjust[item.key].delta" size="small" style="width:120px;" placeholder="0" />
                </div>
                <p v-if="Number(adjust[item.key].delta) > 0" class="preview">
                    调整后：{{ formatAmount(previewAmount(item.key)) }}
                </p>
                <p v-if="minDecreaseError(item.key)" class="max-tip">{{ minDecreaseError(item.key) }}</p>
            </div>
        </div>
        <div class="c-text-r o-mt-l">
            <Button type="info" @click="Cancel()">取消</Button>
            <Button :loading="submitting" type="info" @click="Submit()">确认调整</Button>
        </div>
    </el-dialog>
</template>

<script>
import StoreMix from '@lottery.2.0/mixin/store.modul.js'

const ADJUST_KEYS = ['lhc_amount', 'ssc_amount', 'lhc_cash_balance', 'ssc_cash_balance']

export default {
    name: 'UserAmountModul',
    mixins: [StoreMix],
    data() {
        return {
            store: 'credit/user',
            loading: false,
            submitting: false,
            Params: {},
            agent: {
                info: {}
            },
            subordinate: {
                info: {}
            },
            adjust: this.createAdjust(),
            amountFields: [
                { key: 'lhc_amount', label: '低频信用额度' },
                { key: 'ssc_amount', label: '高频信用额度' },
                { key: 'lhc_cash_balance', label: '低频现金余额' },
                { key: 'ssc_cash_balance', label: '高频现金余额' },
            ],
        }
    },
    methods: {
        createAdjust() {
            const adjust = {}
            for (const key of ADJUST_KEYS) {
                adjust[key] = { mode: 1, delta: 0 }
            }
            return adjust
        },
        resetAdjust() {
            this.adjust = this.createAdjust()
        },
        formatAmount(val) {
            const num = Number(val)
            return isNaN(num) ? 0 : num
        },
        previewAmount(key) {
            return this.applyDelta(key, this.Params[key], this.adjust[key])
        },
        applyDelta(key, base, adj) {
            const delta = Number(adj.delta) || 0
            if (delta <= 0) {
                return this.formatAmount(base)
            }
            const current = this.formatAmount(base)
            if (adj.mode === 1) {
                return current + delta
            }
            const minAmount = this.isCreditKey(key) ? this.usedAmount(key) : 0
            return Math.max(minAmount, current - delta)
        },
        isCreditKey(key) {
            return key === 'lhc_amount' || key === 'ssc_amount'
        },
        usedAmount(key) {
            const sub = this.subordinate.info || {}
            const type = Number(this.Params.type)
            if (key === 'lhc_amount') {
                if (type === 1) {
                    return this.formatAmount(sub.lhc_use_balance)
                }
                return Math.max(0, this.formatAmount(this.Params.lhc_amount) - this.formatAmount(sub.lhc_balance))
            }
            if (key === 'ssc_amount') {
                if (type === 1) {
                    return this.formatAmount(sub.ssc_use_balance)
                }
                return Math.max(0, this.formatAmount(this.Params.ssc_amount) - this.formatAmount(sub.ssc_balance))
            }
            return 0
        },
        usedAmountHint(key) {
            return this.isCreditKey(key) ? this.usedAmount(key) : 0
        },
        minDecreaseError(key) {
            const adj = this.adjust[key]
            const delta = Number(adj.delta) || 0
            if (adj.mode !== -1 || delta <= 0 || !this.isCreditKey(key)) {
                return ''
            }
            const used = this.usedAmount(key)
            const next = this.formatAmount(this.Params[key]) - delta
            if (next < used) {
                return `减少后不能低于已用额度（${used}）`
            }
            return ''
        },
        maxIncreaseHint(key) {
            if (this.agent.info && this.agent.info.is_admin) {
                return '无限制'
            }
            const agent = this.agent.info || {}
            try {
                switch (key) {
                    case 'lhc_amount':
                        return this.formatAmount(
                            this.Big(agent.lhc_balance || 0).sub(agent.lhc_use_balance || 0).toNumber()
                        )
                    case 'ssc_amount':
                        return this.formatAmount(agent.ssc_balance)
                    case 'lhc_cash_balance':
                        return this.formatAmount(agent.lhc_cash_balance)
                    case 'ssc_cash_balance':
                        return this.formatAmount(agent.ssc_cash_balance)
                    default:
                        return 0
                }
            } catch (err) {
                return 0
            }
        },
        init() {
            this.resetAdjust()
            this.Params = this.Origin(this.form || {})
            this.agent.info = {}
            this.subordinate.info = {}
            this.loading = true
            const pid = this.Params.pid || this.User.id
            const subId = this.Params.id
            const requests = [
                this.Dp('myTeam/_GET_USER', { id: pid, only: 'amount_agent_' + pid }),
            ]
            if (subId) {
                requests.push(this.Dp('myTeam/_GET_USER', { id: subId, only: 'amount_sub_' + subId }))
            }
            Promise.all(requests).then((results) => {
                const agentRes = results[0]
                const subRes = results[1]
                this.agent.info = (agentRes && agentRes.data) || {}
                this.subordinate.info = (subRes && subRes.data) || {}
            }).catch(() => {
                this.Err('加载额度信息失败')
            }).finally(() => {
                this.loading = false
            })
        },
        hasAdjust() {
            return ADJUST_KEYS.some(key => Number(this.adjust[key].delta) > 0)
        },
        Submit() {
            if (!this.hasAdjust()) {
                return this.Err('请输入调整金额')
            }
            for (const key of ADJUST_KEYS) {
                const err = this.minDecreaseError(key)
                if (err) {
                    return this.Err(err)
                }
                const next = this.previewAmount(key)
                if (next < 0) {
                    return this.Err('调整后额度不能小于 0')
                }
            }
            const params = this.Origin(this.Params)
            for (const key of ADJUST_KEYS) {
                params[key] = this.previewAmount(key)
            }
            params.action = 'info'
            params.type = this.Params.type
            if (!params.has_games_type && this.Params.has_games_type) {
                params.has_games_type = this.Params.has_games_type
            }
            if (this.agent.info && this.agent.info.is_admin) {
                params._proportion = params.lhc_proportion_max
            }
            this.submitting = true
            this.Put(params, 'user', (res) => {
                this.submitting = false
                if (res) {
                    this.Suc('额度调整成功')
                    this.$emit('finish')
                    this.Cancel()
                }
                return res
            }).catch(() => {
                this.submitting = false
            })
        },
    },
}
</script>
